@let apartmentWithApplicationData = apartmentWithApplicationInfo();
@let user = user$ | async;

@if (apartmentWithApplicationData && user) {
  @let application = apartmentWithApplicationData.application;
  <div class="flex-1">
  <article
    homeyApartmentDetailPageContent
    [apartment]="apartmentWithApplicationData"
    [application]="apartmentWithApplicationData.application"
    [householdSize]="user.householdInfo.size"
    [relevantApartmentsInput]="{ type: 'user', user: user }"
  >
    @if (application && application.status !== 'not-selected') {
      <div trackingBanner class="flex items-center gap-2 text-base font-medium" style="color: #065f46">
        <span class="relative flex h-2.5 w-2.5 items-center justify-center">
          <span class="absolute inline-flex h-full w-full rounded-full opacity-45 animate-ping"
                [style.animation-duration]="'1.6s'"
                [style.transform]="'scale(1.05)'"
                style="background-color: #86efac"></span>
          <span class="relative inline-flex h-2 w-2 rounded-full"
                style="background-color: #10b981; box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.4)"></span>
        </span>
        @if(application.status === 'selected') {
          <span>Check your email for further instructions!</span>
        } @else {
          <span>Tracking application, no action required</span>
        }
      </div>
    }

      @if (application) {
      <homey-lottery-timeline [lottery]="apartmentWithApplicationData" [application]="application"/>

      @if (application.createdAt && application.createdAt < yesterday && application.status === 'not-synced') {
        <p class="text-yellow-500 mt-4 -mx-4 text-sm">
          <i class="pi pi-exclamation-triangle"></i>
          Application is taking longer than expected.
          <br />
          Please wait a little longer, or
          <a class="underline cursor-pointer" [routerLink]="'/support'">
            contact support
          </a>
        </p>
      }
    } @else if (apartmentWithApplicationData.status === 'closed') {
      <p>Lottery closed</p>
    } @else {
      @if ((apartmentWithApplicationData | estimatedEligibility)()) {
        @if (user.status === 'active') {
          <div class="flex flex-row justify-between items-center">
            <p>Eligible</p>
            <homey-submit-button
              class="font-normal flex-shrink-0"
              [submitButtonLabel]="'Apply'"
              size="small"
              [submitFunction]="apply"
            />
          </div>
        } @else if (deferredAwaitingPayment()) {
          <p>Eligible</p>
        } @else {
          <homey-start-next-step-button label="Complete profile to apply"/>
        }
      } @else {
        @if (user.status === 'active') {
          <p>Ineligible</p>
        } @else {
          <p>Likely ineligible</p>
        }
      }
    }

    <ng-container apartmentUnits>
      @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};

      @if (eligibleResult.status === 'ineligible') {
        <homey-apartment-detail-info-item
          icon="pi-warehouse"
          [title]="'Reason for ineligibility'"
        >
          <p>
            @if (eligibleResult.reason === 'household-size-too-high') {
              Maximum household members: {{ apartmentWithApplicationData.unitTypes | maxHouseholdSize }}
            } @else if (eligibleResult.reason === 'income-too-high') {
              Annual household income is above the allowed range.
            } @else if (eligibleResult.reason === 'income-too-low') {
              Annual household income is below the required minimum.
            } @else if (eligibleResult.reason === 'household-size-too-low') {
              Minimum household members: {{ apartmentWithApplicationData.unitTypes | minHouseholdSize }}
            } @else if (eligibleResult.reason === 'senior-ineligible') {
              Requires at least one household member aged 62 or older.
            }
          </p>
        </homey-apartment-detail-info-item>
      } @else {
        @if (apartmentWithApplicationData.type === 'regular') {
          @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};
          @if (eligibleResult.status === 'eligible') {
            <homey-apartment-detail-info-item
              icon="pi-warehouse"
              title="Eligible units">
              <homey-regular-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
            </homey-apartment-detail-info-item>
          }
        }
        @else {
          @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};
          @if (eligibleResult.status === 'eligible') {
            <homey-apartment-detail-info-item
              icon="pi-warehouse"
              title="Eligible units">
              <homey-senior-eligible-units [eligibleUnits]="eligibleResult.apartments" />
            </homey-apartment-detail-info-item>
          }
        }
      }
    </ng-container>
  </article>


  @if (application && (application.status === 'applied' || application.status === 'pending-selection' || application.status === 'not-synced')) {
    <div class="pt-8">
    @if (application.manuallyWithdrawn) {
      <p class="text-surface-500">
        You have withdrawn this application.
      </p>
    } @else {
      <p-button
        severity="danger"
        size="small"
        (onClick)="onWithdrawClick()"
        label="Withdraw application"
      />
    }
      </div>
  }

  </div>

  @if (deferredAwaitingPayment()) {
    <homey-auto-apply-sticky-footer/>
  }
}
<p-confirm-dialog key="lottery-confirm"/>
